import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import {Grid, Avatar} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    avatar: {
		height: 'inherit',
		width: '100%',
    },
    container: {
        width: '80%',
        margin: 'auto',
        paddingLeft: '20px',
        paddingRight: '20px',
        [theme.breakpoints.down('xs')]: {
			width: '100%',
		},
    },
}));

function ShowImages(props) {
    const classes=useStyles();
    return (
        <Grid container spacing = {3} className={classes.container}>
            {(props.images)? props.images.map((image) => {
                return (
                    <Grid item xs={12} sm={6} md={4}>
                        <Avatar variant="square" className={classes.avatar} src={image} />
                    </Grid>
                )
            })
            :null}
        </Grid>
    )
}

export default ShowImages;